var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var RadioButtonOff = function RadioButtonOff(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default RadioButtonOff;